export default "__VITE_ASSET__437205ee__"